var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckin = function SvgCheckin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M69.642 15.265a1 1 0 1 0-1.47-1.356L56.657 26.397v-5.734a2 2 0 0 0-2-2h-42.75a2 2 0 0 0-2 2v42.75a2 2 0 0 0 2 2h42.75a2 2 0 0 0 2-2V29.348zM54.657 28.566l-18.75 20.336-16.011-14.009a1 1 0 0 0-1.317 1.505l16.743 14.65a1 1 0 0 0 1.394-.074l17.941-19.457v31.896h-42.75v-42.75h42.75z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckin;